import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";
import { Template } from "../models/templates.model";

@Injectable({
  providedIn: "root",
})
export class TemplatesService {
  env = environment.env;
  maintenanceTemplatesURL = endpointsURL.maintenanceTemplatesURL;

  constructor(private httpClient: HttpClient) {}

  public list(filters: string) {
    return this.httpClient.get(
      `${this.env}${this.maintenanceTemplatesURL}/lista${filters}`
    );
  }

  public getTemplate(idTemplate: string): Observable<Template> {
    idTemplate = encodeURIComponent(idTemplate);
    return this.httpClient.get<Template>(
      `${this.env}${this.maintenanceTemplatesURL}?_identificador=${idTemplate}`
    );
  }

  public getTemplateSync(idTemplate: string): Promise<any> {
    idTemplate = encodeURIComponent(idTemplate);
    return new Promise<any>((resolve, reject) => {
      this.httpClient
        .get(
          `${this.env}${this.maintenanceTemplatesURL}?_identificador=${idTemplate}`
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  public createTemplate(template): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceTemplatesURL}`,
      template
    );
  }

  public updateTemplate(template): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.maintenanceTemplatesURL}`,
      template
    );
  }

  public removeTemplate(templateIds: string[]): Observable<any> {
    let params = new HttpParams();

    templateIds.forEach((e) => {
      params = params.append("_Identificador", e);
    });
    return this.httpClient.delete<any>(
      `${this.env}${this.maintenanceTemplatesURL}`,
      { params: params }
    );
  }
}
